module.exports = __webpack_public_path__ + "static/Grupo 80-013d24959cae2f968bcdda44bd248e9d.svg";